<template>
    <div>
        <BreadCrumb :data="breadCrumb"  />

        <b-card class="formGroup">
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
            <TicketMessage v-else :ticket='ticket' :comments='comments' :expired="expired"/>
            <template slot="footer">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="pageInfo.count"
                    :per-page="pageInfo.limit"
                ></b-pagination>
            </template>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import TicketMessage from './components/TicketMessage'
    import Modals from './modals/index.vue'
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n'
    import moment from 'moment'

    let breadCrumb = [
        { label: i18n.t('pages.ticket.name'), url: "/Ticket/List" },
    ]
    
    export default {
        name: 'TicketDetail',

        data: function(){
            return{
                breadCrumb,
                expired: false,
                modalOpen: false,
                modalProps: {},
                currentForm:"Ticket",
                modalName: "",
                currentPage: 1,
                offset: 0,
                s:'',
                params:{
                    limit:10,
                    offset: 0,
                }
            }
        },
        watch: {
            currentPage(val){
                this.setPage(val)
            },
            offset(val){
                this.params['offset'] = val
                this.$store.dispatch('fetchComments',{id: this.ticketId, params: {limit: this.params.limit, offset: val, comment: s}} )
            }
        },
        methods:{
            setPage:function(page){
                if(page > 0){
                    this.page = page
                    this.params.offset = ((page-1) * this.params.limit)
                    this.offset = ((page-1) * this.params.limit)

                }
            },
            openModal(state, modal, props) {
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            compareSubDate(){
                 if(moment().isAfter(this.$store.getters.ticket.customer_subs.end_date)){
                    this.openModal(true, 'expired', this.$store.getters.ticket)
                    this.expired = true
                 }
                 
            }
        },
        components:{
            BreadCrumb,TicketMessage, Modals
        },
        computed: {
            loading() {
                return this.$store.getters.getTicketLoading
            },
            ticketId() {
                return this.$route.params.id
            },
            ticket() {
                return this.$store.getters.ticket
            },
            comments() {
                return this.$store.getters.getTicketComments
            },
            pageInfo() {
                return this.$store.getters.getCommentPageInfo  
            },
        },
        async created() {
            await this.$store.dispatch('fetchTicket', this.ticketId)
            await this.$store.dispatch('fetchComments', {id: this.ticketId, params: this.params} )
            this.compareSubDate()
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/Detail.vue